import type { StripeElementsOptions } from "@stripe/stripe-js";
import { type PropsWithChildren, useMemo } from "react";

import { Provider } from "./client";

export {
  useCreateCardToken,
  useCreateStripeBankAccount,
  useCreateStripePlatformPayToken,
} from "./client";

export const StripeProvider = ({
  children,
  countryCode,
  test,
  ...props
}: PropsWithChildren<{
  elementsOptions?: StripeElementsOptions;
  merchantIdentifier: string;
  countryCode?: string;
  test: boolean;
  urlScheme: string;
}>) => {
  const publishableKey = useMemo(() => {
    switch (countryCode) {
      case "NO":
        return test
          ? "pk_test_51PJFIbEZQwYm88fJHahnZ6zEfvA8Yv2PpGzeUjXeW0ykD0o4pSjNUPQytaspGfeSCFwH3C36dugm6Ww3V0P3em4Q00P7nEhsou"
          : "pk_live_51PJFIbEZQwYm88fJp4dC6HkXphpzH28BMtdX702dHGEypmSvpuXEHgVT8gYqeDXANM0BJZNsfky43zWpMJFfwqWT00tO7EvBwr";

      default:
        return test
          ? "pk_test_eXlYeOtI8On76oJupvapZ7nG00GSYu0khZ"
          : "pk_live_7gg2SevcL8zLIlNQhlNPsVTu0025jVYYgo";
    }
  }, [test, countryCode]);

  return (
    <Provider {...props} publishableKey={publishableKey}>
      {children}
    </Provider>
  );
};
